// src/components/TranscriptionTile.jsx
import React, { useEffect, useState, useRef } from "react";
import {
  useTrackTranscription,
  useLocalParticipant,
} from "@livekit/components-react";
import { LocalParticipant } from "livekit-client";
import { useChat } from "../hooks/useChat";

export function TranscriptionTile({ agentAudioTrack, accentColor }) {
  const { addMessage } = useChat();
  const agentMessages = useTrackTranscription(agentAudioTrack);
  const localParticipant = useLocalParticipant();
  const localMessages = useTrackTranscription({
    publication: localParticipant.microphoneTrack,
    source: "microphone",
    participant: localParticipant.localParticipant,
  });

  // Local transcripts state is still maintained for UI display
  const [transcripts, setTranscripts] = useState([]);
  // Ref to track processed segment IDs to avoid duplicate additions
  const processedSegmentsRef = useRef({});

  useEffect(() => {
    // Create a new map of transcripts from scratch
    const newTranscripts = new Map();

    // Process agent transcription segments
    agentMessages.segments.forEach((s) => {
      newTranscripts.set(
        s.id,
        segmentToChatMessage(s, undefined, agentAudioTrack.participant)
      );
    });

    // Process local transcription segments
    localMessages.segments.forEach((s) => {
      newTranscripts.set(
        s.id,
        segmentToChatMessage(s, undefined, localParticipant.localParticipant)
      );
    });

    // Convert to array and sort chronologically by timestamp
    const sortedSegments = [...newTranscripts.values()].sort(
      (a, b) => a.timestamp - b.timestamp
    );

    // Only add/update messages for segments marked as final
    sortedSegments.forEach((msg) => {
      if (msg.final) {
        // Only add/update if this segment hasn't been processed with the final text
        if (processedSegmentsRef.current[msg.id] !== msg.message) {
          // For a real app, if an update function exists, call it here instead
          if (!processedSegmentsRef.current[msg.id]) {
            addMessage({
              id: msg.id, // include a unique id for keying
              role: msg.isSelf ? "user" : "assistant",
              content: msg.message,
              timestamp: msg.timestamp,
            });
          }
          processedSegmentsRef.current[msg.id] = msg.message;
        }
      }
    });

    // Update local state for display (sorted)
    setTranscripts(sortedSegments);
  }, [
    agentMessages.segments,
    localMessages.segments,
    agentAudioTrack.participant,
    localParticipant.localParticipant,
    addMessage,
  ]);

//   return (
//     <div style={{ border: `1px solid ${accentColor}`, padding: "1rem" }}>
//       <h2>Live Transcriptions</h2>
//       {transcripts.map((t) => (
//         <div key={t.id}>
//           <strong>{t.name}:</strong> {t.message}
//         </div>
//       ))}
//     </div>
//   );
}

function segmentToChatMessage(s, existingMessage, participant) {
  return {
    id: s.id,
    final: s.final,       // flag indicating if the segment is final
    message: s.final ? s.text : `${s.text} ...`,
    name: participant instanceof LocalParticipant ? "You" : "Agent",
    isSelf: participant instanceof LocalParticipant,
    timestamp: existingMessage?.timestamp || Date.now(),
  };
}
